import { deprecated_353C43, deprecated_FFB200 } from '../../styles/deprecated-colors';

export const File = ({
    lineColor = deprecated_353C43,
    color = deprecated_FFB200,
    strokeWidth = '2.7',
}: {
    lineColor?: string;
    color?: string;
    strokeWidth?: string;
}): JSX.Element => (
    <svg viewBox="0 0 239 239" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-584.000000, -301.000000)">
                <g transform="translate(586.000000, 300.000000)">
                    <circle id="Oval" fill={color} cx="189" cy="192" r="48" />
                    <g
                        transform="translate(189.000000, 0.000000)"
                        stroke={color}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={strokeWidth}
                    >
                        <path d="M18,11.7 L14.4,11.7" />
                        <path d="M3.6,11.7 L0,11.7" />
                        <path d="M8.7,20.7 L8.7,17.1" />
                        <path d="M8.7,6.6 L8.7,2.7" />
                    </g>
                    <g
                        transform="translate(0.000000, 12.000000)"
                        stroke={color}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={strokeWidth}
                    >
                        <path d="M18.3,11.1 L14.7,11.1" />
                        <path d="M3.9,11.1 L0.3,11.1" />
                        <path d="M9.3,20.1 L9.3,16.5" />
                        <path d="M9.3,5.7 L9.3,2.1" />
                    </g>
                    <g
                        transform="translate(19.000000, 23.000000)"
                        stroke={lineColor}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={strokeWidth}
                    >
                        <g>
                            <polyline points="18.5 53.2 18.5 0.1 89.6 0.1 107.3 26.5 187.1 26.5 187.1 53.2" />
                            <path d="M162.5,213.7 L41.6,213.7 C23.3,213.7 7.7,199.6 6.2,181.3 L0.8,77.2 L204.8,77.2 L197.9,181 C196.4,199.6 181.1,213.7 162.5,213.7 Z" />
                        </g>
                        <g transform="translate(59.000000, 100.000000)">
                            <path d="M42.9,2.1 C66.9,1.8 86.4,20.7 87,44.7 C87.3,68.7 68.4,88.2 44.4,88.8 C20.4,89.1 0.9,70.2 0.3,46.2 C0,22.2 19.2,2.4 42.9,2.1 Z" />
                            <path
                                d="M0.6,46.2 L87,44.7 M10.5,17.4 C15.3,20.4 22.2,25.2 43.5,24.9 C64.8,24.6 70.2,19.8 75.9,16.5 M77.4,72.6 C72.6,69.6 65.4,64.5 44.1,64.8 C22.8,65.1 16.8,70.2 11.1,73.5"
                                id="Shape"
                            />
                            <path d="M43.5,2.1 C53.7,1.8 62.1,21.3 62.4,45 C62.7,68.7 54.9,88.5 44.7,88.5 C34.5,88.8 26.1,69.3 25.8,45.6 C25.5,21.9 33.3,2.4 43.5,2.1 Z" />
                        </g>
                    </g>
                    <path
                        d="M18.3,87.9 L223.8,87.9"
                        stroke={color}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeDasharray="3,18"
                    />
                    <path
                        d="M53.1,73.2 L189,73.2"
                        stroke={color}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeDasharray="3,18"
                    />
                </g>
            </g>
        </g>
    </svg>
);
